export default __webpack_public_path__ + "img/75cb4f1ccc96aee897e6cc9cfe0d8233.svg";